import Vue from 'vue'

export const userDataProcessing = {
    getters: {
        getUserDataProcessingSections: () => {
            return Vue.prototype.$brand.footer.dataProcessing
        }
    }
}